module.exports = __webpack_public_path__ + "static/img/Testimonial2.94ffa9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial2.png
// module id = tH18
// module chunks = 0